import { Form, Radio } from 'antd';

const FormRadioGroup = ({
  label,
  name,
  options,
  value,
  onChange,
  optionType = 'default',
  disabled = false,
  rules,
  help,
}) => {
  return (
    <Form.Item label={label} name={name} rules={rules} help={help}>
      <Radio.Group
        options={options}
        value={value}
        onChange={(e) => onChange && onChange(e.target.value)}
        optionType={optionType}
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default FormRadioGroup;
